import React from "react";
import "./BingoCell.css";

interface BingoCellProps {
  text: string;
  marked: boolean;
  isWinning?: boolean;
  index?: number;
  gridSize?: number;
  clickCount?: number;
  onToggle: () => void;
}

export const BingoCell: React.FC<BingoCellProps> = ({
  text,
  marked,
  isWinning = false,
  index = -1,
  gridSize = 4,
  clickCount = 0,
  onToggle,
}) => {
  // Determine corner position
  const isTopLeft = index === 0;
  const isTopRight = index === gridSize - 1;
  const isBottomLeft = index === gridSize * (gridSize - 1);
  const isBottomRight = index === gridSize * gridSize - 1;

  const classNames = [
    "bingo-cell",
    marked ? "bingo-cell--marked" : "",
    isWinning ? "bingo-cell--winning" : "",
    isTopLeft ? "bingo-cell--corner-tl" : "",
    isTopRight ? "bingo-cell--corner-tr" : "",
    isBottomLeft ? "bingo-cell--corner-bl" : "",
    isBottomRight ? "bingo-cell--corner-br" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classNames} onClick={onToggle} type="button">
      {clickCount > 0 && (
        <span className="bingo-cell__count">{clickCount}</span>
      )}
      {marked && (
        <span className="bingo-cell__x-mark">
          <svg viewBox="0 0 100 100" fill="currentColor">
            <path d="M15 10 L55 50 L90 10 Q95 5 90 15 L60 50 L95 85 Q100 95 90 90 L55 55 L20 90 Q10 95 15 85 L45 50 L10 15 Q5 5 15 10 Z" />
          </svg>
        </span>
      )}
      <span className="bingo-cell__text">{text}</span>
    </button>
  );
};
